import type { IdentifiedUser } from '@onefootprint/request-types';

type GetDisplayPhoneProps = {
  user?: IdentifiedUser;
  phoneNumber?: string;
};

export const getDisplayPhone = ({ user, phoneNumber }: GetDisplayPhoneProps) => {
  const isLoginChallenge = !!user;
  if (isLoginChallenge && !user.matchingFps?.includes('id.phone_number')) {
    return user?.scrubbedPhone?.replace(/\*/g, '•').replace(/ /g, '\u00A0').replace(/-/g, '\u2011');
  }
  const match = phoneNumber?.match(/(\+\d{1,3} )?(.*)/);
  if (!match) {
    return undefined;
  }
  const countryCode = match[1] ? match[1] : '';
  const number = match[2];
  return (countryCode + number).replace(/ /g, '\u00A0').replace(/-/g, '\u2011');
};

type GetDisplayEmailProps = {
  user?: IdentifiedUser;
  email?: string;
};

export const getDisplayEmail = ({ user, email }: GetDisplayEmailProps) => {
  const isLoginChallenge = !!user;

  if (isLoginChallenge && !user.matchingFps?.includes('id.email')) {
    return user?.scrubbedEmail?.replace(/\*/g, '•');
  }
  return email;
};
